/* assets/ndl-popup.js */
(function () {
  if (window.customElements.get('ndl-popup')) return;

  var DAY_MS = 86400000;

  // Reine Entscheidungsfunktion: true = Popup anzeigen.
  // Hinweis: Bei frequency = 0 Tagen gilt "jetzt - ts > 0", d.h. das Popup
  // erscheint bei jedem Seitenaufruf erneut (0 = keine Pause, nicht "nie").
  function shouldShow(state, freqDays, freqConvertedDays, now) {
    if (!state) return true;
    var days = state.action === 'converted' ? freqConvertedDays : freqDays;
    return now - state.ts > days * DAY_MS;
  }

  function readState(key) {
    try {
      var raw = window.localStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  // true, wenn die Seite im Shopify Theme-Editor (Design Mode) läuft.
  function isDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function writeState(key, action, now) {
    // Im Theme-Editor nichts speichern, damit die Vorschau nicht den
    // localStorage echter Besuche verändert.
    if (isDesignMode()) return;
    try {
      window.localStorage.setItem(key, JSON.stringify({ ts: now, action: action }));
    } catch (e) {
      /* localStorage nicht verfügbar (Privatmodus) – still ignorieren */
    }
  }

  class NdlPopup extends HTMLElement {
    connectedCallback() {
      this.campaignId = (this.getAttribute('campaign-id') || '').trim();
      if (!this.campaignId) return;

      // Targeting
      if (this.hasAttribute('only-index') && this.getAttribute('page-type') !== 'index') return;
      if (this.hasAttribute('only-visitors') && this.hasAttribute('is-customer')) return;

      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;

      this.storageKey = 'ndl:popup:' + this.campaignId;
      this.freqDays = parseInt(this.getAttribute('frequency-days') || '0', 10);
      this.freqConvertedDays = parseInt(this.getAttribute('frequency-days-converted') || '0', 10);
      this.delayMs = parseInt(this.getAttribute('apparition-delay') || '0', 10) * 1000;
      this.converted = false;

      // Im Theme-Editor das Gate umgehen, damit das Popup zur Bearbeitung
      // immer erscheint (und nicht durch einen alten Eintrag blockiert wird).
      var state = readState(this.storageKey);
      if (!isDesignMode() && !shouldShow(state, this.freqDays, this.freqConvertedDays, Date.now())) return;

      this.bindEvents();
      this.timer = window.setTimeout(this.show.bind(this), this.delayMs);
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
    }

    show() {
      if (this.dialog && this.dialog.isConnected && !this.dialog.open) {
        this.dialog.showModal();
        writeState(this.storageKey, 'shown', Date.now());
      }
    }

    bindEvents() {
      var self = this;

      this.querySelectorAll('[data-ndl-close]').forEach(function (el) {
        el.addEventListener('click', function () {
          self.dialog.close();
        });
      });

      this.querySelectorAll('[data-ndl-convert]').forEach(function (el) {
        el.addEventListener('click', function () {
          self.converted = true;
          writeState(self.storageKey, 'converted', Date.now());
        });
      });

      // Rabattcode: in die Zwischenablage kopieren UND Rabatt im Hintergrund
      // aktivieren (kein Seitenwechsel). Klick zählt zugleich als "converted".
      this.querySelectorAll('[data-ndl-copy]').forEach(function (el) {
        el.addEventListener('click', function () {
          var code = el.getAttribute('data-code') || '';
          var url = el.getAttribute('data-discount-url');

          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(code).catch(function () {});
          }
          // Rabatt aktivieren – im Editor unterdrücken, damit die Vorschau
          // keinen Rabatt in die Session legt.
          if (url && !isDesignMode()) {
            fetch(url, { credentials: 'same-origin' }).catch(function () {});
          }

          self.converted = true;
          writeState(self.storageKey, 'converted', Date.now());

          // Hinweiszeile kurz auf Bestätigung umstellen
          var hint = el.querySelector('[data-ndl-copy-hint]');
          if (hint) {
            if (!el.dataset.originalHint) el.dataset.originalHint = hint.textContent;
            var copied = el.getAttribute('data-copied-text');
            if (copied) hint.textContent = copied;
            el.classList.add('is-copied');
            window.clearTimeout(el._copyTimer);
            el._copyTimer = window.setTimeout(function () {
              hint.textContent = el.dataset.originalHint;
              el.classList.remove('is-copied');
            }, 3000);
          }
        });
      });

      // Klick auf den abgedunkelten Backdrop schließt das Dialog
      this.dialog.addEventListener('click', function (e) {
        if (e.target === self.dialog) self.dialog.close();
      });

      // Beim Schließen (X / Backdrop / Esc): dismissed merken, außer bereits converted
      this.dialog.addEventListener('close', function () {
        if (!self.converted) writeState(self.storageKey, 'dismissed', Date.now());
      });
    }
  }

  window.customElements.define('ndl-popup', NdlPopup);
})();
